import type { RouteObject } from "react-router-dom";
import Applications from "@/pages/application/Applications";
import CreateApplication from "@/pages/application/CreateApplication";
import EditApplication from "@/pages/application/EditApplication";

export const applicationRoutes: RouteObject[] = [
  { path: "/applications", element: <Applications /> },
  { path: "/applications/create", element: <CreateApplication /> },
  { path: "/applications/:id/edit", element:  <EditApplication /> },
];
